import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { BasePolicy } from "../policy/BasePolicy";

export enum DLPAction {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
}

export const DLPPolicy = Type.Intersect([
  BasePolicy,
  Type.Object({
    action: Type.Union([Type.Literal(DLPAction.ALLOW), Type.Literal(DLPAction.BLOCK)]),
    priority: Type.Number(),
    shouldOpenIncident: Type.Optional(Type.Boolean()),
  }),
]);
export type DLPPolicy = TypeBoxToType<typeof DLPPolicy>;
export type DLPPolicyCondition = DLPPolicy["conditions"][number];

const LAST_DLP_UPDATE_CACHE_KEY = "policies:update";
export const getLastDLPUpdateCacheKey = (orgId: string) => {
  return `${LAST_DLP_UPDATE_CACHE_KEY}:${orgId}`;
};
